import { Container, Grid, Typography, Box } from "@mui/material";
import { Lightbulb, Business, AccessTime, Rocket } from "@mui/icons-material";

function Information() {
  const infoCards = [
    {
      icon: <Lightbulb sx={{ fontSize: 40 }} />,
      title: "Explore The Possibilities",
      description:
        "Have a friendly chat with one of our project managers and learn how we can help you with your business. Two heads are better than one, let's think about it together!",
    },
    {
      icon: <Business sx={{ fontSize: 40 }} />,
      title: "For Established Businesses",
      description:
        "If you are already a well established business, we can optimize and automate your business cycle and help you grow.",
    },
    {
      icon: <AccessTime sx={{ fontSize: 40 }} />,
      title: "Save Time & Money",
      description:
        "We are 100% hassle free. We take care of everything from planning to implementation to ongoing maintenance, so you can focus on the things that matter to you.",
    },
    {
      icon: <Rocket sx={{ fontSize: 40 }} />,
      title: "For New Businesses",
      description:
        "If you are a new business or just starting out, we can turn your ideas into reality, fast and reliably because we already know what works and what doesn't.",
    },
  ];

  return (
    <Box
      component="section"
      sx={{
        py: 8,
        paddingY: { xs: 8, md: 12 },
        background: "#fff",
        position: "relative",
      }}
    >
      <Container maxWidth="lg">
        <Box textAlign="center" mb={6}>
          <Typography
            variant="h3"
            sx={{
              fontWeight: 800,
              color: "#1a1a1a",
              mb: 2,
            }}
          >
            Why Choose The DevHouse
          </Typography>

          <Typography
            variant="h6"
            sx={{
              color: "rgba(0,0,0,0.6)",
              fontWeight: 400,
              maxWidth: "600px",
              mx: "auto",
            }}
          >
            Discover how we transform businesses through innovative software
            solutions
          </Typography>
        </Box>

        <Grid container spacing={4}>
          {infoCards.map((card, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Box
                sx={{
                  p: 4,
                  height: "100%",
                  background: "#ffffff",
                  borderRadius: "16px",
                  border: "1px solid rgba(0,0,0,0.05)",
                  boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
                  textAlign: "center",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-5px)",
                    boxShadow: "0 12px 30px rgba(0,0,0,0.12)",
                    borderColor: "#0A8EF2",
                  },
                }}
              >
                <Box
                  className="icon-container"
                  sx={{
                    width: 70,
                    height: 70,
                    borderRadius: "50%",
                    mx: "auto",
                    mb: 3,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "rgba(4, 104, 191, .04)",
                    color: "#0A8EF2",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      backgroundColor: "#0A8EF2",
                      color: "#fff",
                    },
                  }}
                >
                  {card.icon}
                </Box>

                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 600,
                    color: "#1a1a1a",
                    mb: 1.5,
                    lineHeight: 1.3,
                  }}
                >
                  {card.title}
                </Typography>

                {/* الوصف */}
                <Typography
                  variant="body2"
                  sx={{
                    color: "rgba(0,0,0,0.7)",
                    lineHeight: 1.6,
                    fontSize: "0.95rem",
                  }}
                >
                  {card.description}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}

export default Information;
